@if (true) {
    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><label> {{ModelFor}}</label></h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>
  <div class="container-fluid">
    <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
        {{TypeHeader}}
        <form [formGroup]="FormSearchContactOrg" (ngSubmit)="onSearchContactOrg(FormSearchContactOrg.value)">
            <div class="d-flex">
              <div class="input-group">
                <input type="text" placeholder="Search here..." class="table-search-input form-control"
                  formControlName="txtSearch">
                <span class="input-group-btn">
                  <button class="btn btn-primary" title="Search">
                    <i class="fas fa-magnifying-glass"></i>
                  </button>
                </span>
              </div>
            <button class="btn btn-outline-primary mx-2" [routerLink]="TypeHeader == 'Contact' ? '/addorgcontact/0/0' : '/addorgcontact/1/0'" title="Create">
                <i class="fas fa-plus"></i>
            </button>
            </div>
        </form>
    </div>
        <div class="card table-container"> 
            <table class="custom-table">
                <thead>
                <tr>
                <th>S.No.</th>
                    <th>Name</th>
                    <th> {{pagetype == '1' ? 'Organization Code' : 'Customer Code'}} </th>
                    <th>Address</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    @if (this.pagetype == '0'){
                        <th>Designation</th>
                        <th>Department</th>
                    }
                    <th>Contact Type</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody >
                <app-table-state [loading]="MsgType == 1" [error]="MsgType == 3 ? 'Something went wrong while fetching data.' : null" [empty]="filteredData?.length == 0" [rows]="10"
                    [columns]="10"></app-table-state>
                    @if (filteredData?.length > 0) {
                        @for (mDtl of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track $index) {
                            <tr>
                                <td align="center">{{(pageNumber - 1) * pageSize + $index +1 }}</td>
                                <td> {{mDtl.Name}} </td>
                                <td> {{mDtl.Code}} </td>
                                <td> {{mDtl.Address}}<br>{{mDtl.City}} &nbsp; &nbsp; {{mDtl.State}} </td>
                                <td> {{mDtl.Mobile}} </td>
                                <td> {{mDtl.Email1}} </td>
                                @if (pagetype == '0') {
                                    <td> {{mDtl.Designation}} </td>
                                    <td> {{mDtl.Department}} </td>
                                }
                                <td> {{mDtl.Lawyer}} </td>
                                @if (RightsID.includes('202034001') || RightsID.includes('202034021')) {
                                    <td>
                                        <button class="icon-btn icon-btn-primary" [routerLink]="'/addorgcontact/' + mDtl.type + '/' + mDtl.ID" >
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }@else {
                                    <td>
                                        <button class="icon-btn icon-btn-primary" routerLink="module/0" >
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
        @if (filteredData?.length > 0) {
            <div class="d-flex justify-content-between my-3 w-100">
                <div class="w-50">
                    <app-rows-per-page
                    [pageSize]="pageSize"
                    [total]="totalRecords"
                    [pageIndex]="pageNumber"
                    (pageSizeChange)="onPageSizeChange($event)">
                </app-rows-per-page>
                </div>
                <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
            </div>
        }
  </div>
} @else {
    <my-content placeholder="navigation">
    
    
        <div class="col-sm-12 divbordergry "></div>
        <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
            <div class="modal-dialog-FactSheet">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><label> {{ModelFor}}</label></h4><br>
                        <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body  col-sm-12 form-group">
                        <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="col-sm-12" style="margin-top: 8px;">
            <div class="col-sm-12" style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
                <div class="col-sm-4">
                    <form #SearchContactOrg="ngForm" [formGroup]="FormSearchContactOrg" (ngSubmit)="onSearchContactOrg(SearchContactOrg.value);">
                        <div class="col-sm-2 text-left height-34">Search</div>
                        <div class="col-sm-7"><input class="form-control" formControlName="txtSearch" placeholder="Search here" name="txtSearch" type="text" value=""></div>
                        <div class="col-sm-3"><input class="btn btn-primary btn-sm-12" type="submit" value="Go"></div>
                        <!-- <div class="col-sm-2"> <a href="#" class="btn btn-primary btn-sm-12" data-toggle="modal" (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP">Advance Search</a>
                        </div> -->
                    </form>
                </div>
                <div class="col-sm-6">&nbsp;</div>
                <!-- <div class="col-sm-2">
                    <div class="col-sm-12 height-34" *ngIf="this.pagetype == 'Contact'">&nbsp;
                        <a href="#/report/207041000" data-toggle="modal">Contact Listing</a>
                    </div>
                    <div class="col-sm-12 height-34" *ngIf="this.pagetype == 'Org'">&nbsp;
                        <a href="#/report/207042000" data-toggle="modal">Organization Listing</a>
                    </div>
                </div> -->
            </div>
        </div>
    
        <div class="col-sm-12" style="margin-top: 8px;">
            <div class=" col-sm-12 lefticonD paddingless" style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
                <label>{{TypeHeader}} </label>
            </div>
            <table width="100%" class="LMtable">
                <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th *ngIf="this.pagetype == '0'"> Customer Code</th>
                    <th *ngIf="this.pagetype == '1'"> Organization Code</th>
                    <th>Address</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    <th *ngIf="this.pagetype == '0'">Designation</th>
                    <th *ngIf="this.pagetype == '0'">Department</th>
                    <th>Lawyer</th>
                    <th>Action</th>
                    <!-- <th align="center"><input type="checkbox" id="CheckData"></th> -->
                </tr>
    
                <!-- ============== Show Message /  Loading ============== -->
                <tr *ngIf="this.MsgType == 1">
                    <td colspan="80">
                        <div class="d-flex align-items-center">
                            <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                            <div class="spinner-border" role="status"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 2">
                    <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                        <span>{{DisplayMessage}}</span>
                    </td>
                </tr>
                <tr *ngIf="this.MsgType == 3">
                    <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                    </td>
                </tr>
                <!-- ==================================================== -->
    
                <tr *ngFor="let mDtl of master | paginate: { itemsPerPage: 7, currentPage: pageNumber }; let i=index ">
                    <td align="center">{{(pageNumber - 1) * 7 + i +1 }}</td>
                    <td> {{mDtl.Name}} </td>
                    <td> {{mDtl.Code}} </td>
                    <td> {{mDtl.Address}}<br>{{mDtl.City}} &nbsp; &nbsp; {{mDtl.State}} </td>
                    <td> {{mDtl.Mobile}} </td>
                    <td> {{mDtl.Email1}} </td>
                    <td *ngIf="this.pagetype == '0'"> {{mDtl.Designation}} </td>
                    <td *ngIf="this.pagetype == '0'"> {{mDtl.Department}} </td>
                    <td> {{mDtl.Lawyer}} </td>
                    <td>
                        <div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ; then EditContactLink else EditContactNotLink"></div>
                        <ng-template #EditContactLink>
                            <a target="_blank" routerLink="/addorgcontact/{{mDtl.type}}/{{mDtl.ID}}"> <img src="assets/resources/images/edit.png"> </a>
                        </ng-template>
                        <ng-template #EditContactNotLink>
                            <a href="module/0"><img src="assets/resources/images/edit.png"></a>
                        </ng-template>
    
                    </td>
                    <!-- <td align="center"> <input type="checkbox" id="{{mDtl.ID}}"> </td> -->
                </tr>
            </table> <br>
    
            <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
    
        </div>
    
    
        <div><br>&nbsp;<br></div>
        <div class="form-group mt-2" style="display:none;">
            <div class="form-check">
                <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                <label for="autoClose">Auto close alert after three seconds</label>
            </div>
    
        </div>
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-3 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </my-content>
    <my-content placeholder="main">
    
    </my-content>
}